var jQuery, $ = require('jquery');

$(document).ready(() => {

    $('.ae-post-list-item').each(($id, $item) => {
        $($item).find('.elementor-widget-ae-woo-add-to-cart').appendTo($($item).find('.elementor-widget-ae-post-image'));

    });
	

	$('#billing_postcode').trigger('update_checkout'); 

});


// WEBPACK FOOTER //
// ./assets/src/js/app.js